export default __webpack_public_path__ + "static/media/property_344.6b2ed008.png";